export * from "./src/get-map-object-sitemap";
